import '../styles/success-icon.scss';

// взят с макета, т.к. у компонента "CheckCircleTwoTone" из "@ant-design/icons" не получилось убрать границу
export const SuccessIcon = () => (
    <div className="success-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
            <path d="M37.8593 5.625H34.7387C34.3012 5.625 33.886 5.82589 33.6182 6.16964L15.2119 29.4866L6.38605 18.3036C6.25253 18.1341 6.08235 17.997 5.88828 17.9027C5.69421 17.8083 5.48129 17.7592 5.26551 17.7589H2.14497C1.84587 17.7589 1.68069 18.1027 1.86372 18.3348L14.0914 33.8259C14.6628 34.5491 15.761 34.5491 16.3369 33.8259L38.1405 6.19643C38.3235 5.96875 38.1584 5.625 37.8593 5.625Z" fill="#52C41A" />
        </svg>
    </div>
);